/** ArcLifecycleContent — renders `arc_lifecycle` entries (deploy / complete / cancel / fail). */
import React from 'react';
import { useTranslation } from 'localization';
import { TimelineEvent } from 'types/timeline';

interface Props {
  event: TimelineEvent;
}

const ArcLifecycleContent: React.FC<Props> = ({ event }) => {
  const { t } = useTranslation();
  const payload = (event.payload ?? {}) as { lifecycle?: string; templateSystemName?: string };

  return (
    <div className="timeline-event-content">
      <span className="timeline-event-content__text">
        {t('timeline.eventContent.arcLifecycle', {
          lifecycle: payload.lifecycle ?? '',
          template: payload.templateSystemName ?? '',
        })}
      </span>
    </div>
  );
};

export default ArcLifecycleContent;
